import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import iconLeft from "../../../../../assets/images/Event-2024/icon-number-loto-left.png";
import iconCenter from "../../../../../assets/images/Event-2024/icon-number-loto-center.png";
import iconLast from "../../../../../assets/images/Event-2024/icon-number-loto-last.png";
import SlotCounter from "react-slot-counter";
import moment from "moment/moment";
import PopupComponentError from "../../components/Popup/PopupComponentError";
import iconIp16 from "../../../../../assets/images/Event-2024/Frame 82 1.png";
import iconNgSuccess from "../../../../../assets/images/Event-2024/image 92.png";
import iconTh from "../../../../../assets/images/Event-2024/image 91.png";
import { useTranslation } from "react-i18next";
import { setData, getData } from "../../../../../utils/localstorage";

const TYPE_ACTION_LOTO = {
  pow: 0,
  start: 1,
  end: 2,
};
const durationTime = 15;
const dummyCharacterCountTime = 2.5;
export default function LotoNumber({
  codeDetail = {},
  endTimerLotoRealtime,
  open,
  setOpen,
}) {
  const { t } = useTranslation();
  const [typeActionLoti, setTypeActionLoto] = useState(TYPE_ACTION_LOTO.pow);
  const [timeDifference, setTimeDifference] = useState(0);
  // const [open, setOpen] = useState(false);
  const dataPopup = useRef({
    imgMain: "",
    imgLeft: "",
    imgRight: "",
    contentHeader: "",
    descriptionHeader: "",
    descriptionFooter: "",
    contentAction: "",
    isFailsAll: false,
    action: () => {},
  });

  const { codeWin, codeWinTime, isdnWin } = codeDetail;

  let splitCode = [];
  if (codeWin) {
    splitCode = codeWin.split("");
  }

  const handleShowPopupWinner = () => {
    setOpen(true);
    setTypeActionLoto(TYPE_ACTION_LOTO.end);

    dataPopup.current = {
      imgMain: iconIp16,
      imgLeft: iconNgSuccess,
      imgRight: iconTh,
      contentHeader: `${t("event_new_year.congrats")}`,
      descriptionHeader: `ဂုဏ်ယူပါတယ်! 🎉 ${isdnWin || ""} သည် ကုဒ် ${
        codeWin || ""
      } ဖြင့် အံ့သြဖွယ်ကောင်းသော IPHONE16 ၏ နှစ်သစ်ကူး အထူးဆု ကို ရရှိသွားပါပြီ!!!`,
      descriptionFooter: `${t("event_new_year.mytel_will_contact")}`,
      contentAction: `${t("event_new_year.close")}`,
      action: () => {
        setOpen(false);
        setData("hiddenPopupWin", true);
      },
    };
  };

  useEffect(() => {
    if (!codeWinTime) {
      return setTypeActionLoto(TYPE_ACTION_LOTO.pow);
    }

    const givenTime = moment(codeWinTime, "YYYY-MM-DD HH:mm:ss");
    const additionalSeconds = 124;

    // Cộng thêm 124 giây
    const updatedTime = givenTime.add(additionalSeconds, "seconds");
    // Lấy thời gian hiện tại
    const currentTime = moment();

    if (currentTime.isAfter(updatedTime)) {
      setTypeActionLoto(TYPE_ACTION_LOTO.end);
    }
  }, [codeWinTime]);

  useEffect(() => {
    let timer;
    if (codeDetail?.codeWinTime) {
      const dateWinTime = moment(codeWinTime, "YYYY-MM-DD HH:mm:ss"); // golive
      // dateWinTime sẽ thay thế currentDatePlusTimeActive
      // Lấy ngày giờ hiện tại
      const currentDate = moment();
      // Cộng thêm 120 giây vào thời gian hiện tại để mở loto
      // const currentDatePlusTimeActive = currentDate
      //   .clone()
      //   .add(durationTime * splitCode.length - 120, "seconds");

      if (currentDate.isAfter(dateWinTime)) {
        // Tính sự chênh lệch giữa dateA và currentDate + 120s (theo giây)
        // ngày trk lớn hơn ngày sau
        const differenceInSeconds = currentDate.diff(dateWinTime, "seconds");
        if (differenceInSeconds < durationTime * splitCode.length + 1) {
          setTypeActionLoto(TYPE_ACTION_LOTO.start);
          setTimeDifference(differenceInSeconds);
        }
        timer = setTimeout(() => {
          handleShowPopupWinner();
        }, 121000 - differenceInSeconds * 1000);
        // console.log(
        //   `Ngày a lớn hơn ngày hiện tại + 120s, chênh lệch là ${differenceInSeconds} giây.`
        // );
      } else if (currentDate.isAfter(dateWinTime)) {
        setTypeActionLoto(TYPE_ACTION_LOTO.start);
        timer = setTimeout(() => {
          handleShowPopupWinner();
        }, 121000);
      } else {
        // console.log("Ngày a không lớn hơn ngày hiện tại + 120s.");
      }
    }
    return () => clearTimeout(timer);
  }, [codeDetail, endTimerLotoRealtime]);

  const option = [
    <div className="number-active-loto">0</div>,
    <div className="number-active-loto">1</div>,
    <div className="number-active-loto">2</div>,
    <div className="number-active-loto">3</div>,
    <div className="number-active-loto">4</div>,
    <div className="number-active-loto">5</div>,
    <div className="number-active-loto">6</div>,
    <div className="number-active-loto">7</div>,
    <div className="number-active-loto">8</div>,
    <div className="number-active-loto">9</div>,
  ];

  return (
    <Div>
      {codeWin && !getData("hiddenPopupWin") ? (
        <PopupComponentError
          open={open}
          setOpen={setOpen}
          data={dataPopup.current}
          handleActionHidden={() => {
            setData("hiddenPopupWin", true);
          }}
          isCodeWin
        />
      ) : null}

      {!splitCode ||
      typeActionLoti !== TYPE_ACTION_LOTO.start ||
      !codeWinTime ? (
        <>
          {typeActionLoti === TYPE_ACTION_LOTO.end ? (
            <>
              <div className="number-loto loto-number-moot">
                <img src={iconLeft} alt="" />
                <div className="number-detail number-detail-end">
                  {splitCode[0]}
                </div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail number-detail-end">
                  {splitCode[1]}
                </div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail number-detail-end">
                  {splitCode[2]}
                </div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail number-detail-end">
                  {splitCode[3]}
                </div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail number-detail-end">
                  {splitCode[4]}
                </div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail number-detail-end">
                  {splitCode[5]}
                </div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail number-detail-end">
                  {splitCode[6]}
                </div>
              </div>
              <div className="number-loto loto-number-moot">
                <img src={iconLast} alt="" />
                <div className="number-detail number-detail-end">
                  {splitCode[7]}
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="number-loto loto-number-moot">
                <img src={iconLeft} alt="" />
                <div className="number-detail">-</div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail">-</div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail">-</div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail">-</div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail">-</div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail">-</div>
              </div>
              <div className="number-loto">
                <img src={iconCenter} alt="" />
                <div className="number-detail">-</div>
              </div>
              <div className="number-loto loto-number-moot">
                <img src={iconLast} alt="" />
                <div className="number-detail">-</div>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          {splitCode.map((item, index) => {
            const timerDuration = durationTime * (index + 1);
            let isFinishedItem = false;
            let timerLast = 0;

            if (
              typeActionLoti === TYPE_ACTION_LOTO.start &&
              timeDifference > timerDuration
            ) {
              // các item đã qua khi lần đâu vào trang
              isFinishedItem = true;
            }
            if (
              typeActionLoti === TYPE_ACTION_LOTO.start &&
              timeDifference < timerDuration
            ) {
              if (timeDifference + durationTime > timerDuration) {
                // item đang quay khi lần đầu vào trang
                timerLast = timerDuration - timeDifference;
              }
            }
            return (
              <div
                className={`number-loto ${
                  index === 0 || index === splitCode.length - 1
                    ? "loto-number-moot"
                    : ""
                }`}
                key={index}
              >
                <img
                  src={
                    index === 0
                      ? iconLeft
                      : index === splitCode.length - 1
                      ? iconLast
                      : iconCenter
                  }
                  alt=""
                />
                <div className="number-detail">
                  <SlotCounter
                    value={[<div className="number-active-loto">{item}</div>]}
                    startValue={[
                      <div className="number-active-loto">
                        {isFinishedItem ? item : "-"}
                      </div>,
                    ]}
                    duration={timerDuration - timerLast - timeDifference} // Khớp với thời gian trong setTimeout
                    dummyCharacterCount={dummyCharacterCountTime}
                    delay={10.5} // Thêm độ trễ nếu cần
                    autoAnimationStart={isFinishedItem ? false : true} // Chỉ chạy SlotCounter hiện tại
                    dummyCharacters={option}
                  />
                </div>
              </div>
            );
          })}
        </>
      )}
    </Div>
  );
}

const Div = styled.div`
  position: absolute;
  z-index: 6;
  top: 218px;
  left: 95px;
  display: flex;
  gap: 2px;

  .number-detail-end {
    font-weight: 400 !important;
    font-size: 18px !important;
  }

  .number-active-loto {
    line-height: 50px;
  }

  .number-detail {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 24px;
    font-weight: bold;
  }

  .number-loto {
    position: relative;
    width: max-content;
    height: max-content;
  }

  div img {
    width: 34px;
  }

  .loto-number-moot {
    img {
      width: 36px;
    }
  }

  .last-number {
    transform: rotate(180deg);
  }

  @media (max-width: 992px) {
    .number-active-loto {
      line-height: 40px;
    }
  }

  @media (max-width: 576px) {
    top: 180px;
    left: 78.5px;
    div img {
      width: 26px;
    }
    .loto-number-moot img {
      width: 28px;
    }
  }
  /* .loto-item {
        width: 37px;
        height: 60px;
        border-radius: 3px;
        border-top-left-radius: 4.67px;
        border-bottom-left-radius: 4.67px;
        background-color: white;
        color: black;
        font-weight: bold;
        font-size: 16px;
        box-shadow: inset 0 0px 5px rgba(114, 23, 22, 0.71);
    } */

  @media screen and (max-width: 1400px) {
    top: 175px;
    left: 78.5px;

    .number-loto {
      img {
        width: 26px;
      }
    }

    .loto-number-moot img {
      width: 28px;
    }
  }

  @media (max-width: 576px) {
    top: 138px;
    left: 48%;
    transform: translateX(-50%);
    width: 175px;

    .loto-number-moot img {
      width: 25px !important;
    }

    .number-active-loto {
      font-size: 14px;
      line-height: 30px;
    }

    .number-loto {
      img {
        width: 23px;
      }
    }
  }
`;
